// import 'whatwg-fetch';
import axios from 'axios-jsonp-pro';

export default {
	//已经申请数量
	hasApplyNum(userid) {
		return axios({
			method: 'get',
			url: '//zprecommend.58.com/obtainResumeDeliverNum?userid=' + userid,
			timeout: 10000,
			withCredentials: true
		}).then(response => response.data);
	},
	//分批次请求每一部分数据
	getData(tagid, page, mcity, source, dispcateid) {
		return axios({
			method: 'get',
			url: '//zprecommend.58.com/api/abtest/?ptype=aggregation_infolist&platform=2&page=' + page + '&tagid=' + tagid + '&mcity=' + mcity + '&source=' + source + '&dispcateid=' + dispcateid,
			timeout: 10000,
			withCredentials: true
		}).then(response => response.data);
	},
	/**
	 * 优选数据上报 场景 申请简历投递，不需要关心返回
	 * @param {string} url 上报地址 
	 */
	dataReport({url}) {
		return axios.jsonp(url, {timeout: 10000})
	}
};



// WEBPACK FOOTER //
// ./src/api/index.js